import theme from '@styles/theme';
export default {
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
    p: ['16px 16px 16px 16px', '16px 16px 16px 16px', '40px 20px 40px 40px', '40px 20px 40px 40px'],
    overflow: 'hidden',
    '.swiper': {
      position: 'relative',
      width: '100%',
      height: 'calc( 100vh - 137px )'
    },
    '.swiper-scrollbar': {
      width: '2px',
      right: 0
    },
    '.swiper-slide': {
      width: '100%',
      height: 'auto'
    }
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alingContent: 'start-flex',
    width: '100%',
    height: 'auto',
    pr: '20px',
    mb: '40px',
    font: theme.fonts.uniform,
    p: {
      fontSize: theme.fontSizes.caption,
      width: '100%',
      mb: '8px'
    },
    span: {
      width: '100%'
    }
  }
};